import React from 'react';
import type { BuilderSection } from 'types/websiteBuilder';
import { HeaderSectionEditor } from '../sections/HeaderSection';
import { BodySectionEditor } from '../sections/BodySection';
import { HeroSectionEditor } from '../sections/HeroSection';
import { FeaturesSectionEditor } from '../sections/FeaturesSection';
import { TestimonialsSectionEditor } from '../sections/TestimonialsSection';
import { FAQSectionEditor } from '../sections/FAQSection';
import { CTASectionEditor } from '../sections/CTASection';
import { FooterSectionEditor } from '../sections/FooterSection';
import { TeamSectionEditor } from '../sections/TeamSection';
import { GallerySectionEditor } from '../sections/GallerySection';
import { SliderSectionEditor } from '../sections/SliderSection';
import { NavigationTilesSectionEditor } from '../sections/NavigationTilesSection';
import { CampaignHeroSectionEditor } from '../sections/CampaignHeroSection';
import styles from './SectionEditorPanel.module.scss';

const SECTION_EDITORS: Record<
  BuilderSection['type'],
  React.ComponentType<{
    data: Record<string, unknown>;
    onUpdateData: (data: Record<string, unknown>) => void;
  }>
> = {
  header: HeaderSectionEditor,
  body: BodySectionEditor,
  hero: HeroSectionEditor,
  features: FeaturesSectionEditor,
  testimonials: TestimonialsSectionEditor,
  faq: FAQSectionEditor,
  cta: CTASectionEditor,
  footer: FooterSectionEditor,
  team: TeamSectionEditor,
  gallery: GallerySectionEditor,
  marquee: SliderSectionEditor,
  navigationTiles: NavigationTilesSectionEditor,
  campaignHero: CampaignHeroSectionEditor,
};

interface SectionEditorPanelProps {
  section: BuilderSection;
  onUpdateData: (data: Record<string, unknown>) => void;
}

function SectionEditorPanel({
  section,
  onUpdateData,
}: SectionEditorPanelProps) {
  const Editor = SECTION_EDITORS[section.type];

  if (!Editor) {
    return (
      <div className={styles.panel}>
        <p className={styles.unknown}>Unknown section type: {section.type}</p>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.editorContent}>
        <Editor data={section.data} onUpdateData={onUpdateData} />
      </div>
    </div>
  );
}

export default SectionEditorPanel;
